var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCols(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C9.44772 0 9 0.447715 9 1V3C9 3.55228 9.44771 4 10 4H15C15.5523 4 16 3.55228 16 3V1C16 0.447715 15.5523 0 15 0H10ZM1 9C0.447715 9 0 9.44771 0 10V12C0 12.5523 0.447715 13 1 13H6C6.55228 13 7 12.5523 7 12V10C7 9.44771 6.55228 9 6 9H1ZM0 1C0 0.447715 0.447715 0 1 0H6C6.55228 0 7 0.447715 7 1V6C7 6.55228 6.55228 7 6 7H1C0.447715 7 0 6.55228 0 6V1ZM10 6C9.44772 6 9 6.44772 9 7V12C9 12.5523 9.44771 13 10 13H15C15.5523 13 16 12.5523 16 12V7C16 6.44772 15.5523 6 15 6H10Z",
    fill: "#999999"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCols);
export default __webpack_public_path__ + "static/media/cols.c1a849f031dea2476064aa1d4d1e61f2.svg";
export { ForwardRef as ReactComponent };